<form #form="ngForm">
  <div class="row g-0">
    <div class="col-lg-7 pr-lg-min-3">
      <div class="row g-0">
        <div class="col-7 col-sm-8 pe-3">
          <label class="font-xl fw-bold mb-2"
                 *ngIf="!reminder.id"
                 [translate]="'profile.cakeCalendars.reminders.personName'"
          >Person name</label>
          <input class="form-control"
                 name="fullName"
                 [maxlength]="32"
                 placeholder="{{ 'profile.cakeCalendars.reminders.personNamePlaceholder' | translate }}"
                 [(ngModel)]="reminder.personName"
                 (ngModelChange)="onFieldUpdate.next({isValid: form.valid})"
                 required>
        </div>
        <div class="col-5 col-sm-4">
          <label class="font-xl fw-bold mb-2"
                 *ngIf="!reminder.id"
                 [translate]="'profile.cakeCalendars.reminders.date'">Date</label>
          <ui-datepicker-popup
            [(model)]="$any(reminder).targetDate"
            [controlName]="'date'"
            [placeholder]="'dd/mm/yyyy'"
            [placement]="'bottom-right'"
            (modelChange)="$any(reminder).targetDate = $event; onFieldUpdate.next({isValid: form.valid})"
          ></ui-datepicker-popup>
        </div>
      </div>
    </div>
    <div class="col-lg-5 mt-md-max-3">
      <div class="row g-0">
        <div class="col-7 col-sm-8 pe-3">
          <label class="font-xl fw-bold mb-2"
                 *ngIf="!reminder.id"
                 [translate]="'profile.cakeCalendars.reminders.occasion'"
          >Reason</label>
          <ui-select [items]="reminderReasons"
                     [model]="reason"
                     [extraClasses]="'w-100'"
                     (modelChange)="reminder.reason = $event.value; onFieldUpdate.next({isValid: form.valid})"
          ></ui-select>
        </div>
        <div class="col-5 col-sm-4 action-col">
          <ng-container *ngIf="reminder.id">
            <i class="icon-trash pointer p-2"
               (click)="onRemoving.emit(reminder.id)"></i>
          </ng-container>
          <ng-container *ngIf="!reminder.id">
            <button class="btn btn-primary w-100"
                    (click)="onSaving.emit(reminder)"
                    [disabled]="form.invalid || !reminder.targetDate"
                    [translate]="'profile.cakeCalendars.reminders.add'">
              Save
            </button>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</form>
